export const REDIRECT_PARAM = 'redirect';
const DEFAULT_REDIRECT_PATH = '/';
const EXCLUDED_PATHS = ['/login', '/logout'];

export function getSafeRedirectPath(redirect: string | null | undefined): string {
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//') || redirect.startsWith('/\\')) {
    return DEFAULT_REDIRECT_PATH;
  }
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F]/.test(redirect)) {
    return DEFAULT_REDIRECT_PATH;
  }

  try {
    const { origin } = window.location;
    const url = new URL(redirect, origin);
    if (url.origin !== origin || EXCLUDED_PATHS.includes(url.pathname)) {
      return DEFAULT_REDIRECT_PATH;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return DEFAULT_REDIRECT_PATH;
  }
}

export function buildLoginPath(location: { pathname: string; search?: string; hash?: string }): string {
  const target = `${location.pathname}${location.search || ''}${location.hash || ''}`;
  if (getSafeRedirectPath(target) === DEFAULT_REDIRECT_PATH) {
    return '/login';
  }
  return `/login?${new URLSearchParams({ [REDIRECT_PARAM]: target }).toString()}`;
}
